import { TableCell } from "@mui/material";
import GenericInput from "../../../../../common/GenericInput";
import { TEXT_ALIGN } from "../../../../../utils/enums";

const InputCell = ({
  type,
  value,
  onChangeHandler,
  className = "",
  textAlign = TEXT_ALIGN.left,
}: {
  type: string;
  value: string;
  className?: string;
  textAlign?: TEXT_ALIGN;
  onChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  return (
    <TableCell align="center">
      <GenericInput
        className={className}
        type={type}
        value={value}
        onChange={onChangeHandler}
        textAlign={textAlign}
      />
    </TableCell>
  );
};

export default InputCell;
